import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Events } from 'ionic-angular';
import { AppSettings } from '../config/app-settings';
import firebase from 'firebase';

declare var window: any;

@Injectable()
export class FirebaseStorage {
	public storage: any;
  public events: any;

	constructor(
    public settings: AppSettings
    ){    	
		this.storage = firebase.storage().ref(); 
    this.events = new Events();
  }

  public uploadFile(filePath, fileUri){
    var self = this;
    return Observable.create((observer) => {
      
      let metadata = {
        contentType: 'image/jpeg'
      };
      // Get FileEntry from fileUri
      self.getFileEntry(fileUri).subscribe((fileEntry)=>{
        let fname = Date.now() + fileEntry.name;
        console.log(fname);
        filePath = filePath + fname;
        // Read image
        fileEntry.file(function(file){
            var reader = new FileReader();
            reader.onloadend = function(data){
                // console.log("Successful file read: " + this.result);
                // console.log("Posting file to Firebase");
                var blob = new Blob([new Uint8Array(this.result)], { type: "image/jpeg" });

                // console.log("Sending files to FireBase Storage");
                // console.log(AppSettings.DEFAULT_POST_IMAGE_LOCATION + '/' + filePath);
                // console.log(fileEntry);
                // console.log(blob);
                
                var uploadTask = self.storage.child(filePath).put(blob, metadata);
                // var uploadTask = self.storage.child(filePath).put(blob);
                // Listen for errors and completion of the upload.
                // [START oncomplete]
                uploadTask.on('state_changed', null, function(error) {
                  // [START onfailure]
                  console.error('Upload failed:', error);
                  // [END onfailure]
                }, function() {
                  // console.log('Uploaded',uploadTask.snapshot.totalBytes,'bytes.');
                  // console.log(uploadTask.snapshot.metadata);
                  
                  var url = uploadTask.snapshot.metadata.downloadURLs[0];
                  console.log('File available at', url);        
                  observer.next({name: fname, url:url});
                });
                // [END oncomplete]
            }

            reader.readAsArrayBuffer(file);
        }, function(){
            // Error
        })
                   
      });

      // this.events.publish(EventCodes.DATA_LOADING, true);

      
    });    
  }
  
  public getFileEntry(imgUri) {
      return Observable.create((observer)=>{
        window.resolveLocalFileSystemURL(imgUri, function success(fileEntry) {
            observer.next(fileEntry);
        }, function () {
        observer.next(null);
        });
      })
  }
}


// WEBPACK FOOTER //
// ./src/providers/firebase-storage.ts